module.exports = require('wix-ui-icons-common/X.js');



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/new-icons/X.js
// module id = 202
// module chunks = 0